export function getIdContoNumConto() {
	const idConto = window.appConfig && window.appConfig['ID_CONTO'];
	const numConto = window.appConfig && window.appConfig['NUM_CONTO'];
    return idConto && numConto && [idConto,numConto].join(';');
}
